import Footer from "../../components/layout/Footer";
import Header from "../../components/layout/Header";
import LoadingScreen from "../../components/loadingScreen";
import { useUserContext } from "../../hooks/useUserContext";

export default function OrdersPage() {
  const { isLoading } = useUserContext();

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#F9FAFB] font-sans">
      <Header />
      <main className="flex-1" />
      <Footer />
    </div>
  );
}
